export default {
  labels: {
    signed_by: 'Unterzeichnet von {{name}} am {{date}}',
    signed_by_no_date: 'Unterzeichnet von {{name}}',
  },
  buttons: {
    retry: 'Erneut versuchen',
  },
  errors: {
    load_failed:
      'Der Vertrag konnte nicht geladen werden. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  },
};
